import isNull from 'lodash/isNull';
import Api from '../../../helpers/Api';

// ACTION  TYPE
export const SET_TOTAL_PRIZES = 'SET_TOTAL_PRIZES';
const setTotalPrizes = (totalPrizes) => ({
    type: SET_TOTAL_PRIZES,
    totalPrizes,
});

export const SET_TOTAL_PRIZES_WON = 'SET_TOTAL_PRIZES_WON';
const setTotalPrizesWon = (totalPrizesWon) => ({
    type: SET_TOTAL_PRIZES_WON,
    totalPrizesWon,
});

export const SET_HUNT_REGULATION = 'SET_HUNT_REGULATION';
const setHuntRegulation = (huntRegulation) => ({
    type: SET_HUNT_REGULATION,
    huntRegulation,
});

export const SET_PRIZES_INFO = 'SET_PRIZES_INFO';
const setPrizesInfo = (prizesInfo) => ({
    type: SET_PRIZES_INFO,
    prizesInfo,
});

export const SET_HUNT_ALL_INFOS = 'SET_HUNT_ALL_INFOS';
const setHuntAllInfos = (huntAllInfos) => ({
    type: SET_HUNT_ALL_INFOS,
    huntAllInfos,
});

// note: this currently serves only to avoid a rerequest on the client
export const SET_HUNTE_INFOS_UPDATED = 'SET_HUNTE_INFOS_UPDATED';
const setHuntInfosUpdated = () => ({
    type: SET_HUNTE_INFOS_UPDATED,
    huntInfosUpdated: Date.now(),
});

// ACTION
export const checkInfoActiveHunt = () => (dispatch, getState) => {
    const { huntInfosUpdated } = getState().cacaAoTesouro;
    const updateInterval = 1000 * 60 * 30; // only check every 30 minutes

    // Check if is necessary make the request
    if (!huntInfosUpdated || (Date.now() - huntInfosUpdated) > updateInterval) {
        const query = '/api/v1/cacaAoTesouro/checkInfoActiveHunt';

        return Api.progressGet(dispatch, query)
            .then((json) => {
                const allPromises = [
                    dispatch(setHuntInfosUpdated()),
                ];

                if (!json.data || isNull(json.data)) {
                    allPromises.push([
                        dispatch(setHuntRegulation(null)),
                        dispatch(setPrizesInfo(null)),
                    ]);

                    return Promise.all(allPromises);
                }

                const data = json.data;
                let totalPrizes = 0;
                let totalPrizesWon = 0;
                const prizesInfo = [];
                // every prize has the general data added.
                const huntRegulation = data[0].tx_regulamento;
                const huntAllInfos = {
                    idHunt: data[0].id_tesouro,
                    huntDescription: data[0].tx_descricao,
                    huntSituation: data[0].situacao,
                    huntRegulation,
                    // epoch ms (not Date objects) so the state stays serializable
                    huntEndDate: new Date(data[0].dt_fim).getTime(),
                    huntStartDate: new Date(data[0].dt_inicio).getTime(),
                    bannerMessage: data[0].banner_message,
                };

                data.map((item) => {
                    totalPrizes += (parseInt(item.prizeRemainingQuantity, 10) + parseInt(item.prizesWon, 10));

                    totalPrizesWon += parseInt(item.prizesWon, 10);

                    return prizesInfo.push(
                        {
                            prizeName: item.prizeName,
                            prizeDescription: item.prizeDescription,
                            prizeIcon: item.prizeIcon,
                            prizeRemaining: item.prizeRemainingQuantity,
                            prizeWon: item.prizesWon,
                            numberTotalPrize: parseInt(item.prizesWon, 10) + parseInt(item.prizeRemainingQuantity, 10),
                        },
                    );
                });

                allPromises.push([
                    dispatch(setTotalPrizes(totalPrizes)),
                    dispatch(setTotalPrizesWon(totalPrizesWon)),
                    dispatch(setHuntRegulation(huntRegulation)),
                    dispatch(setPrizesInfo(prizesInfo)),
                    dispatch(setHuntAllInfos(huntAllInfos)),
                ]);

                return Promise.all(allPromises);
            }).catch((error) => {
                throw `checkInfoActiveHunt got error: ${error}`;
            });
    }

    return Promise.resolve(1);
};
